import React from 'react';
import { useAppSelector } from '@src/core/hooks';
import { errorsSelector } from '../../../features/auth';
import { AuthValidation } from '../StyledComponents/AuthStyled';
import { getErrorMessage } from '@src/common';
import { InputArea, InputAttribute, InputLabel } from '../StyledComponents/InputStyled';
import { FormInputInputType } from '@src/core/buyerApiClient';

export interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'autoComplete' | 'name'> {
  name: string;
  type?: FormInputInputType;
  label?: string;
  errorContext?: string;
  issetError?: boolean;
  autoComplete?: boolean;
  maxlength?: number;
}

const Input = ({
  name,
  type = 'text',
  label,
  errorContext,
  required,
  autoComplete = true,
  maxlength,
  onChange,
  onBlur,
  ...rest
}: InputProps) => {
  const errors = useAppSelector(errorsSelector);
  const errorMessage = getErrorMessage(errors[errorContext!], name);

  return (
    <InputArea>
      <InputLabel htmlFor={name}>{label}</InputLabel>
      <InputAttribute
        errorContext={errorContext}
        label={label}
        name={name}
        id={name}
        type={type}
        $issetError={!!errorMessage}
        required={required}
        autoComplete={autoComplete ? 'on' : name}
        maxLength={maxlength}
        onChange={onChange}
        onBlur={onBlur}
        {...rest}
      />
      <AuthValidation>{errorMessage}</AuthValidation>
    </InputArea>
  );
};

export default Input;
